var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-cancel",on:{"click":_vm.evOnClick}},[_vm._v(" CANCELAR ")])}
var staticRenderFns = []

export { render, staticRenderFns }